import { useMemo } from 'react';

import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { DevicesSelectorList } from '../DevicesSelector/DevicesSelectorList';
import { useVideoDevicesOptions } from './useVideoDevicesOptions';

export function VideoDevicesOptions() {
	const { t } = useTranslationsContext();
	const { selected, options } = useVideoDevicesOptions();

	const lists = useMemo(() => {
		return [
			{
				title: t('config.camera'),
				options,
				selected,
			},
		];
	}, [options, selected]);

	return <DevicesSelectorList lists={lists} />;
}
